/**
 * @author Ariel
 * @date 2021-12-23
 */
import React from "react";
import { connect } from "dva";
import { framework_tool, component_tool, utils_tool } from '../../../../tool'
import { WizTableForm } from "../../../common";
import './index.less'

let { WizContainer, modelUtils, WizAvatarUpload, WizOssUpload } = framework_tool
let { WizCard, WizSpin, WizForm, WizButton, Wizmessage, WizCol, WizIcon, WizInput, WizModal } = component_tool
let { Session } = utils_tool

const labelConfig = WizTableForm.Config.shortVideoLabel(this, { apiParams: { type: 6 } })
const categoryConfig = WizTableForm.Config.categoryInfo(this, { apiParams: { type: 15, state: 1 } })


class ShortVideoDetail extends WizContainer {
  componentName = 'shortVideoDetail'

  constructor(props) {
    super(props)
    const { history } = props
    let initialValue = {}
    if (history.location && history.location.record) {
      Session.set('shortVideoInfo', initialValue)
    }
    this.state = {}
  }

  _componentDidMount() {
  }

  propsAndStateOnChange = {
    addShortVideo: this._addShortVideoOver.bind(this)
  }

  _addShortVideoOver(nextProps, nextState) {
    if (nextProps.addShortVideo.code == 1) {
      wizNotice.success('保存成功');
      this.jumpPage('replace', '/shortVideo');
    } else {
      wizNotice.error('提交失败：' + nextProps.addShortVideo.msg);
    }
    return true;
  }

  /**
   * 过滤字段值为undefined&null的字段
   * @param {Object} fieldsValue
   */
  fitterFieldsValue(fieldsValue) {
    let fitterValues = {};
    Object.keys(fieldsValue).forEach(key => {
      const value = fieldsValue[key];
      if (value != null && value != undefined) {
        fitterValues[key] = value;
      }
    });
    /**
     * 图片参数处理
     */
    let video = fitterValues['videoFile']
    if (video && video.length) {
      fitterValues['video'] = video[0]['fileId']
      delete fitterValues['videoFile']
    }
    let remark = fitterValues['videoImgFile']
    if (remark && remark.length) {
      fitterValues['videoImg'] = remark[0]['fileId']
      delete fitterValues['videoImgFile']
    }
    return fitterValues;
  }

  _addShortVideo(values) {
    let apiPath = 'shortVideo/add';
    let fitterValues = this.fitterFieldsValue(values)
    this.doAction({
      path: apiPath,
      payload: {
        key: 'addShortVideo',
        apiParams: { ...fitterValues }
      }
    })
  }

  _validator = (rule, value, callback) => {
    let { changeVideo } = this.state
    if (changeVideo && changeVideo[0]) {
      if (changeVideo[0].status !== 'done') {
        callback('上传视频中')
        return
      }
    }
    callback()
  }

  _render() {
    const { shortVideoLoading } = this.props
    let columns = [
      {
        name: 'id',
        formItem: {
          type: 'hidden',
        }
      },
      {
        title: '标题',
        name: 'title',
        formItem: {
          maxLength: 30,
          placeholder: '标题最多输入30个字',
          rules: [
            {
              required: true,
              message: '请输入标题'
            }
          ],
        }
      },
      {
        title: '介绍',
        name: 'intro',
        formItem: {
          type: 'textarea',
          maxLength: 50,
          placeholder: '介绍最多输入50个字',
        }
      },
      {
        title: '标签',
        name: 'labelIds',
        formItem: {
          ...labelConfig,
          diy: WizTableForm,
          initialValue: [],
          initRows: [],
          selectType: 'checkbox',
          rules: [{
            required: true,
            message: '请选择标签'
          }],
        }
      },
      {
        title: '分类',
        name: 'categoryIds',
        formItem: {
          ...categoryConfig,
          // initialValue: [],
          // initRows: [],
          initialValue: [16000],
          initRows: [{ id: 16000, name: "新能源" }],
          selectType: 'checkbox',
          diy: WizTableForm,
          rules: [{
            required: true,
            message: '请选择分类'
          }],
        }
      },
      {
        title: '发布终端',
        name: 'publishTerminalList',
        formItem: {
          type: 'checkbox',
          rules: [{
            required: true,
            message: '请选择发布终端'
          }],
         // initialValue: [2]
        },
        dict: [
          // { code: 1, codeName: '移动课堂' },
          { code: 2, codeName: '凯迪拉克IQ' },
          { code: 3, codeName: '雪佛兰企微' },
          { code: 4, codeName: '别克企微' },
          { code: 5, codeName: '凯迪拉克企微' },
        ]
      },
      {
        title: '视频文件',
        name: 'video',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator, validateFields } = form
            let { changeVideo, changeVideoTime } = this.state
            let children = changeVideo && changeVideo.length >= 1 ? null : <WizButton>上传视频</WizButton>
            return (
              <>
                {getFieldDecorator('videoFile', {
                  rules: [
                    { required: true, message: '视频文件不能为空' },
                  //  { validator: this._validator }
                  ],
                })(
                  <WizOssUpload
                    key={changeVideoTime}
                    accept={".mp4"}
                    listType={'text'}
                    uploadType={'shortVideo'}
                    multiple={false}
                    beforeUpload={(file, upload, remove) => {
                      let result = true;
                      const isLt300M = file.size / 1024 / 1024 < 1024;
                      if (!isLt300M) {
                        Wizmessage.error('视频不得超过1GB!');
                        result = false;
                      }
                      if (this.state && this.state.changeVideo && this.state.changeVideo.length) {
                        wizNotice.error('只能上传一个视频');
                        result = false;
                      }
                      if (!result) {
                        remove && remove()
                        this.setState({ changeVideoTime: new Date() })
                      }
                      return result
                    }}
                    onChange={(files) => {
                      this.setState({ changeVideo: files }, () => {
                        if (files && files[0] && files[0].status === 'done') {
                          validateFields((error, value) => { })
                        }
                      })
                    }}
                    children={children}
                  />
                )}
              </>
            )
          }
        },
      },
      {
        title: '视频封面',
        name: 'videoImg',
        formItem: {
          type: 'custom',
          render: (record, form) => {
            const { getFieldDecorator } = form
            let { changeVideoImg } = this.state
            let children = changeVideoImg && changeVideoImg.length >= 1 ? null : <WizButton>上传封面</WizButton>
            return (
              <>
                {getFieldDecorator('videoImgFile', {
                  rules: [{ required: true, message: '视频封面不能为空' }],
                })(
                  <WizOssUpload
                    key='shortVideoImg'
                    accept={'.jpg, .jpeg, .png'}
                    listType={'picture-card'}
                    uploadType={'shortVideoImg'}
                    // beforeUpload={(file) => {
                    //   const isLt1M = file.size / 1024 / 1024 < 1;
                    //   if (!isLt1M) {
                    //     Wizmessage.error('图片不得超过1MB!');
                    //   }
                    //   return isLt1M;
                    // }}
                    onChange={(files) => {
                      this.setState({
                        changeVideoImg: files,
                        changeVideoImgTime: new Date()
                      })
                    }}
                    children={children}
                  />
                )}
              </>
            )
          }
        },
      },
      {
        title: '评论开关',
        name: 'commentState',
        formItem: {
          type: 'hidden',
          initialValue: 1
        },
        dict: [
          { code: 1, codeName: '开启' },
          { code: 0, codeName: '关闭' }
        ]
      },
      {
        title: '分享开关',
        name: 'shareState',
        formItem: {
          type: 'hidden',
          initialValue: 1
        },
        dict: [
          { code: 1, codeName: '开启' },
          { code: 0, codeName: '关闭' }
        ]
      },
    ]

    let onSubmit = this._addShortVideo.bind(this)

    let formProps = {
      ref: 'form',
      columns,
      onSubmit,
      record: null,
      preview: null,
      footer: undefined,
      formItemLayout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 17 }
      }
    }

    return (
      <WizCard className='short-video-detail'>
        <WizSpin tip={'加载中'} spinning={shortVideoLoading}>
          <WizForm className={'form-inline'} {...formProps} />
        </WizSpin>
      </WizCard>
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const { shortVideo } = state;
  const addShortVideo = modelUtils.getModelEntity(shortVideo, 'addShortVideo');
  const shortVideoInfo = modelUtils.getModelEntity(shortVideo, 'shortVideoInfo');
  const load = modelUtils.getLoadingState(state, 'shortVideo');
  return {
    addShortVideo,
    shortVideoInfo,
    ...load
  }
}

export default connect(mapStateToProps)(ShortVideoDetail);
